import type { ReviewTypeValue } from '@/constants/review/CycleInstance';
import type { ReviewInstance } from '@/types/review/ReviewInstance';

import { api } from '@/api/api';
import { getUtcOffsetMinutes } from '@/utils/dateUtils';

export default {
    async sendReminder(reviewInstance: ReviewInstance) {
        const response = await api.post(`/reviewinstance/sendreminderemail/${reviewInstance.id}`);

        return response.data;
    },

    async getReviewInstance(reviewInstanceId: string) {
        const response = await api.get(`/reviewinstance/${reviewInstanceId}`);

        return response.data;
    },

    async deleteReviewInstance(reviewInstanceId: string) {
        const response = await api.delete(`/reviewinstance/${reviewInstanceId}`);

        return response.data;
    },

    /** `startDate` and `endDate` are calendar days (`'YYYY-MM-DD'`), not instants. */
    async getLatestReviewInstanceIdByPeriod(params: {
        employeeId: string;
        reviewType: ReviewTypeValue;
        startDate: string;
        endDate: string;
        utcOffsetMinutes?: number;
    }) {
        const response = await api.post('/reviewinstance/latest/by-period', {
            employeeId: params.employeeId,
            reviewType: params.reviewType,
            startDate: params.startDate,
            endDate: params.endDate,
            utcOffsetMinutes: params.utcOffsetMinutes ?? getUtcOffsetMinutes(),
        });
        return response.data.latestReviewInstanceId;
    },
};
